import { HttpHeaders, HttpParams, HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EMPTY, Observable, catchError, tap, throwError } from 'rxjs';
import { IPayorRequest } from 'src/app/features/ncp/components/creditcard/payment/ncpcredit-card-common/payor-request';
import { IPaymentRequest } from 'src/app/features/ncp/components/creditcard/payment/ncpcredit-card-common/payment-request';
import { CommonSettings } from 'epay-library';
import { IConfirmationNumber } from 'src/app/features/ncp/components/creditcard/payment/ncpcredit-card-common/confirmation-number';

@Injectable({
  providedIn: 'root'
})
export class EpayExtendedServiceService {
  gateway = 'EPayGateway/EPay/api/v1/';

  httpOptions = {
    headers: new HttpHeaders(),
    params: new HttpParams(),
  };

  constructor(private http: HttpClient) {}

  resetHeader() {
    this.httpOptions.headers = new HttpHeaders().set(
      'Content-Type',
      'application/json'
    ).set(
      'x-client-id',
      CommonSettings.ClientID
    ).set(
      'x-environment',
      CommonSettings.Environment
    );
  }

  getWebsiteMessage(baseurl: string): Observable<any[]> {
    const gateway = '/v1/websitemessages';
  
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'x-client-id': CommonSettings.ClientID,
      'x-environment': CommonSettings.Environment
    });
  
    const params = {
      clientId: CommonSettings.ClientID
    };
  
    return this.http.get<any[]>(`${baseurl}${gateway}`, { headers, params }).pipe(
      tap((data: any) => {
      }),
      catchError(this.handleError)
    );
  }

  getUserPaysFees(baseurl: string): Observable<any[]> {
    const gateway = 'v1/parameters:fees';
  
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'x-client-id': CommonSettings.ClientID,
      'x-environment': CommonSettings.Environment
    });
  
    const params = {
      clientId: CommonSettings.ClientID
    };
  
    return this.http.get<any[]>(`${baseurl}${gateway}`, { headers, params }).pipe(
      tap((data: any) => {
      }),
      catchError(this.handleError)
    );

    // const hardcodedFeeResponse = [{ CreditCardConveniencePercent: 2.75 }];
    // return new Observable<any[]>(observer => {
    //   observer.next(hardcodedFeeResponse);
    //   observer.complete();
    // });
  }

  postPayorValidation (    
    baseurl: string,
    payor: IPayorRequest
  ): Observable<any[]> {
    const apiCmd = 'PostCases';
    const gateway = 'v1/payments:validatePayor';

    this.resetHeader();
    
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'x-client-id': CommonSettings.ClientID,
      'x-environment': CommonSettings.Environment
    });

    return this.http.post<any[]>(baseurl + gateway, payor, { headers }).pipe(
      tap((data: any) => {
      }),
      catchError(this.handleError)
    );
  }

  postPaymentProcess (    
    baseurl: string,
    payor: IPaymentRequest
  ): Observable<any[]> {
    const apiCmd = 'PostPayment';
    const gateway = 'v1/payments:process';

    this.resetHeader();
    
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'x-client-id': CommonSettings.ClientID,
      'x-environment': CommonSettings.Environment
    });

    return this.http.post<any[]>(baseurl + gateway, payor, { headers }).pipe(
      tap((data: any) => {
      }),
      catchError(this.handleError)
    );
  }

  postUpdateConfirmationNumber (    
    baseurl: string,
    payor: IConfirmationNumber
  ): Observable<any[]> {
    const apiCmd = 'PostUpdateConfirmationNumber';
    const gateway = 'v1/payments:updateConfirmationNumber';

    this.resetHeader();
    
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'x-client-id': CommonSettings.ClientID,
      'x-environment': CommonSettings.Environment
    });

    return this.http.post<any[]>(baseurl + gateway, payor, { headers }).pipe(
      tap((data: any) => {
      }),
      catchError(this.handleError)
    );
  }

  private handleError(err: HttpErrorResponse) {
    if (err.status === 500 || err.status === 404 || err.status === 0) {
      console.warn(`Suppressing error with status ${err.status}`);
      return EMPTY;
    }
  
    return throwError(() => err);
  }
}
